import http from './axios';

export interface CategoryDto {
  id?: number;
  categoryType?: number;
  categoryName?: string;
  categoryDescription?: string;
  categoryLevel?: number;
  categorySort?: number;
  parentEntityId?: number;
  parentCategoryId?: number;
  icon?: string;
  children?: any[];
}

export default class CategoryServices {
  private readonly list_api = '/v1/category/list';
  private readonly info_api = '/v1/category/info';
  private readonly save_api = '/v1/category/save';
  private readonly update_api = '/v1/category/update';
  private readonly remove_api = '/v1/category/delete';

  constructor() {}

  async getList(category?: object): Promise<any> {
    let res: any = await http.get(this.list_api, { params: category });
    return res.payload;
  }

  async getInfo(id: string | number) {
    let res: any = await http.get(this.info_api + '/' + id);
    return res.payload;
  }

  async add(data: CategoryDto) {
    let res: any = await http.post(this.save_api, data);
    return res.header?.code == 200 ? res.payload : false;
  }

  async update(data: CategoryDto): Promise<boolean> {
    let res: any = await http.post(this.update_api, data);
    return res.header?.code == 200;
  }

  async remove(id: string | number) {
    let res: any = await http.post(this.remove_api, [id]);
    return res.header?.code == 200;
  }
}
